export default __webpack_public_path__ + "static/media/playstation.57211279.jpg";